import { camelizedJSONFetch } from "../fetchShim.js";
import { RPC_MERCHANT_SERVICE_ENDPOINT } from "./constants.js";
const retrieveMerchant = async () => camelizedJSONFetch(
  `${RPC_MERCHANT_SERVICE_ENDPOINT}/RetrieveMerchant`,
  { method: "POST", body: JSON.stringify({ merchantId: "me" }) }
);
const getMerchantProfile = async () => camelizedJSONFetch("/api/v1/merchant-profile", {
  method: "GET"
});
export {
  getMerchantProfile,
  retrieveMerchant
};
//# sourceMappingURL=http.js.map
